export enum EAppointmentType {
  pd = 'pd',
  managementFee = 'managementFee',
  icBonus = 'icBonus',
  icComm = 'icComm',
  icPool = 'icPool',
  groupLeader = 'groupLeader',
  member = 'member',
}
